import React from 'react';
import { Trans, useTranslation } from 'next-i18next';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { Link } from '@mui/material';
import DialogButton from 'src/components/DialogButton';
import EditCalendarIcon from 'src/components/icons/EditCalendar';
import { useDialog } from 'src/components/providers/DialogProvider';
import useIsDesktop from 'src/hooks/useIsDesktop';
import Dialog from '../../Dialog/Dialog';
import { DialogNames } from '../DialogRoot';
import * as S from './ImmutableAppointmentDialog.styles';
export let ImmutableAppointmentKind = /*#__PURE__*/function (ImmutableAppointmentKind) {
  ImmutableAppointmentKind["Reschedule"] = "RESCHEDULE";
  ImmutableAppointmentKind["Canceling"] = "CANCELING";
  return ImmutableAppointmentKind;
}({});
export const ImmutableAppointmentDialog = ({
  kind,
  phoneNumber
}) => {
  const {
    t
  } = useTranslation();
  const {
    isOpen,
    closeDialog
  } = useDialog();
  const isDesktop = useIsDesktop();
  const isReschedule = kind === ImmutableAppointmentKind.Reschedule;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    icon: isReschedule ? /*#__PURE__*/React.createElement(EditCalendarIcon, null) : /*#__PURE__*/React.createElement(EventBusyIcon, null),
    dataTestId: DialogNames.ImmutableAppointment,
    onClose: closeDialog,
    title: t(`b2c.immutableAppointmentDialog.${kind.toLowerCase()}.heading`),
    actions: /*#__PURE__*/React.createElement(DialogButton, {
      onClick: closeDialog
    }, t('b2c.buttons.close'))
  }, /*#__PURE__*/React.createElement(S.Text, null, t(`b2c.immutableAppointmentDialog.${kind.toLowerCase()}.message`)), /*#__PURE__*/React.createElement(Trans, {
    values: {
      phoneNumber
    },
    i18nKey: "b2c.immutableAppointmentDialog.message",
    components: [isDesktop ? /*#__PURE__*/React.createElement(React.Fragment, null, phoneNumber) : /*#__PURE__*/React.createElement(Link, {
      variant: "Lato Link 2",
      key: "phone",
      href: `tel:${phoneNumber}`
    })]
  }));
};